'use strict';

import { Company } from './Company';
import { Entity } from './Entity';
import { GlobPlansDisruptionCollection } from '../Collections/Glob/GlobPlansDisruptionCollection';
import { GlobPlansDisruption } from '../Entities/Glob/GlobPlansDisruption';

/*
 *
 */
export const PLAN_TYPE_TYPE = {
  ANC: 'ANC',
  ANNUITY: 'ANNUITY',
  IND: 'IND',
  LIFE: 'LIFE',
  LTC: 'LTC',
  MAPD: 'MAPD',
  PDP: 'PDP',
  SUP: 'SUP',
} as const;

export type PLAN_TYPE_TYPE = (typeof PLAN_TYPE_TYPE)[keyof typeof PLAN_TYPE_TYPE];

export class Plan extends Entity {
  protected planId;
  protected planState;
  protected planCounty;
  protected planName;
  protected planType;
  protected planNumber;
  protected disruptions;
  protected company: Company;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.planId = data.planId;
    this.planState = data.planState;
    this.planCounty = data.planCounty;
    this.planName = data.planName;
    this.planType = data.planType;
    this.planNumber = data.planNumber;

    if (data.company) {
      const company = new Company();

      company.hydrate(data.company);

      this.company = company;
    }

    if (data.disruptions) {
      const disruptions = new GlobPlansDisruptionCollection();

      data.disruptions.forEach((singleDisruptionData) => {
        const disruption = new GlobPlansDisruption();
        disruption.hydrate(singleDisruptionData);

        disruptions.addItem(disruption);
      });

      this.disruptions = disruptions;
    }
  }

  public getPlanId() {
    return this.planId;
  }

  public getPlanState() {
    return this.planState;
  }

  public getPlanCounty() {
    return this.planCounty;
  }

  public getPlanName() {
    return this.planName;
  }

  public getPlanType() {
    return this.planType;
  }

  public getPlanNumber() {
    return this.planNumber;
  }

  public getCompany() {
    return this.company;
  }

  public getDisruptions() {
    return this.disruptions;
  }
}
